import React, { useEffect, useState } from 'react';
import usePermissions from 'hooks/usePermissions';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import Scroller from 'ui-component/Scroller';
import { TbDatabaseExclamation } from 'react-icons/tb';
import useIsMobile from 'utils/isMobileUtils';

// ✅ Clear
const ProductHistory = ({
    productDetails,
}) => {

    const history = useNavigate();
    const [productHistory, setProductHistory] = useState();
    const [allPermissions, hasEveryPermission] = usePermissions();

    const getProductHistory = (id) => {
        api.getProductHistory(id).then((res) => {
            if (res.status) {
                setProductHistory(res?.data)
            }
        })
    };

    useEffect(() => {
        getProductHistory(productDetails?.id);
    }, []);

    const isMobile = useIsMobile();
    if (!isMobile) return (
		<div className="content mt15">
			<div className="row">
				<div className="col-12 ">
					{productHistory?.length > 0 ? (
						<div className="table-responsive-xl">
							<Scroller>
								<table className="table pm-table">
									<thead>
										<tr className='sticky-header '>
											<th scope="col" style={{ width: '170px' }}>Warehouse</th>
											{/* <th scope="col" style={{ width: '95px' }}>Old Stock</th>
											<th scope="col" style={{ width: '95px' }}>New Stock</th> */}
											<th scope="col">Remarks</th>
											<th scope="col" style={{ width: '150px' }}>User</th>
											<th scope="col" style={{ width: '140px' }}>Date</th>

										</tr>
									</thead>
									<tbody>
										{productHistory?.map((row, index) => {
											return (
												<tr key={index} style={{ height: '52px' }}>
													<td className="align-middle font14">
														<a onClick={() => {
															if (hasEveryPermission(['View Warehouse Details (Page)'])) {
																history(`/warehouses/${row?.warehouse?.id}`);
															}
														}}
															target="_blank"
															style={{ cursor: 'pointer' }}
															className="link-list-item"
														>
															{row?.warehouse?.name}
														</a>
													</td>
													{/* <td className="align-middle text-left font14">{row?.old_stock}</td>
													<td className="font14 text-left">{row?.new_stock}</td> */}
													{/* <td className={`text-left font14 ${row?.difference > 0 ? 'positive' : row?.difference < 0 ? 'negative' : ''}`}>{row?.difference}</td> */}
													<td className='text-left'>{row?.action_detail}</td>
													<td className='text=left'>{row?.created_by?.name}</td>
													<td className="text-left font14">{moment(row?.created_at).fromNow()}</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</Scroller>
						</div>
					) : (
						<div className="not-found-container">
							<div className="not-found-icon">
								<TbDatabaseExclamation />
							</div>
							<h6 className="not-found-text">No Data Available</h6>
						</div>
					)}



				</div>

			</div>
		</div>
    );

	return (
		<div className="content mt15">
			<div className="row">
				<div className="col-12">
					{productHistory?.length > 0 ? (
						<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
							{productHistory.map((row, index) => (
								<div
									key={index}
									style={{
										border: '1px solid #eee',
										borderRadius: 10,
										padding: 14,
										background: '#fff',
										boxShadow: '0 1px 4px rgba(0,0,0,0.04)'
									}}
								>
									<div style={{ fontWeight: 600, fontSize: 15, marginBottom: 6 }}>
										{row?.warehouse?.name ? (
											<span
												style={{
													color: '#1976d2',
													cursor: hasEveryPermission(['View Warehouse Details (Page)']) ? 'pointer' : 'default'
												}}
												onClick={() => {
													if (hasEveryPermission(['View Warehouse Details (Page)'])) {
														history(`/warehouses/${row?.warehouse?.id}`);
													}
												}}
											>
												{row?.warehouse?.name}
											</span>
										) : (
											<span style={{ color: '#888' }}>No Warehouse</span>
										)}
									</div>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											fontSize: 14
										}}
									>
										{/* <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
											<div style={{ color: '#888' }}>Old Stock </div>
											<div>{row?.old_stock}</div>
										</div>
										<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
											<div style={{ color: '#888' }}>New Stock </div>
											<div>{row?.new_stock}</div>
										</div> */}
										<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
											<div style={{ color: '#888' }}>Difference </div>
											<div
												style={{
													color: row?.difference > 0 ? '#2e7d32' : row?.difference < 0 ? '#d32f2f' : '#222',
													fontWeight: 500
												}}
											>
												{row?.difference}
											</div>
										</div>
										<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
											<div style={{ color: '#888' }}>User </div>
											<div>{row?.created_by?.name || <div style={{ color: '#bbb' }}>-</div>}</div>
										</div>
										<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
											<div style={{ color: '#888' }}>Date </div>
											<div>{moment(row?.created_at).fromNow()}</div>
										</div>
									</div>
									<div style={{ marginTop: 6, fontSize: 14, display: 'flex', flexDirection: 'column' }}>
										<div style={{ color: '#888', marginBottom: 5 }}>Reason </div>
										<div>{row?.action_detail || <div style={{ color: '#bbb' }}>-</div>}</div>
									</div>
								</div>
							))}
						</div>
					) : (
						<div className="not-found-container" style={{ marginTop: 40 }}>
							<div className="not-found-icon">
								<TbDatabaseExclamation />
							</div>
							<h6 className="not-found-text">No Data Available</h6>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default ProductHistory;
